import { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { modifierMonAcces } from '../services/authService';
import '../assets/styles/Parametrage.css';

/**
 * Paramètres d'accès du formateur connecté : son identifiant de connexion
 * et son mot de passe. Le mot de passe actuel est exigé pour toute
 * modification ; le nouveau est facultatif (on peut ne changer que
 * l'identifiant).
 */
function AccesFormateurModal({ onClose }) {
  const { utilisateur, setUtilisateur } = useAuth();
  const [identifiant, setIdentifiant] = useState(utilisateur?.identifiant || '');
  const [actuel, setActuel] = useState('');
  const [nouveau, setNouveau] = useState('');
  const [confirmation, setConfirmation] = useState('');
  const [enCours, setEnCours] = useState(false);
  const [erreur, setErreur] = useState(null);
  const [fait, setFait] = useState(false);

  async function enregistrer(e) {
    e.preventDefault();
    setErreur(null);
    if (!actuel) {
      setErreur('Saisissez votre mot de passe actuel pour confirmer.');
      return;
    }
    if (nouveau && nouveau !== confirmation) {
      setErreur('La confirmation ne correspond pas au nouveau mot de passe.');
      return;
    }
    setEnCours(true);
    try {
      const res = await modifierMonAcces({ identifiant: identifiant.trim(), actuel, nouveau });
      setUtilisateur((prev) => ({ ...(prev || {}), ...(res.data || {}) }));
      setFait(true);
      setActuel('');
      setNouveau('');
      setConfirmation('');
    } catch (err) {
      setErreur(err.message || 'Modification impossible.');
    } finally {
      setEnCours(false);
    }
  }

  return (
    <div className="param-modal-overlay" onClick={enCours ? undefined : onClose}>
      <div className="param-modal param-modal-sm" onClick={(e) => e.stopPropagation()}>
        <div className="param-modal-header">
          <h2 className="param-modal-title">Paramètres d’accès</h2>
          <button type="button" className="param-modal-close" onClick={onClose} disabled={enCours}>
            ×
          </button>
        </div>
        <form className="param-form param-modal-body" onSubmit={enregistrer}>
          {erreur && <div className="param-form-message param-form-message-error">{erreur}</div>}
          {fait && !erreur && (
            <div className="param-form-message">Votre accès a été mis à jour.</div>
          )}

          <label className="param-field">
            <span className="param-label">Identifiant de connexion</span>
            <input
              type="text"
              className="param-input"
              value={identifiant}
              onChange={(e) => setIdentifiant(e.target.value)}
              autoComplete="username"
              required
            />
          </label>
          <div className="param-card-note">
            Vous pouvez aussi vous connecter avec votre adresse email : {utilisateur?.email}.
          </div>

          <label className="param-field">
            <span className="param-label">Mot de passe actuel</span>
            <input
              type="password"
              className="param-input"
              value={actuel}
              onChange={(e) => setActuel(e.target.value)}
              autoComplete="current-password"
              required
            />
          </label>
          <label className="param-field">
            <span className="param-label">Nouveau mot de passe (facultatif)</span>
            <input
              type="password"
              className="param-input"
              value={nouveau}
              onChange={(e) => setNouveau(e.target.value)}
              autoComplete="new-password"
              minLength={8}
              placeholder="8 caractères minimum"
            />
          </label>
          {nouveau && (
            <label className="param-field">
              <span className="param-label">Confirmer le nouveau mot de passe</span>
              <input
                type="password"
                className="param-input"
                value={confirmation}
                onChange={(e) => setConfirmation(e.target.value)}
                autoComplete="new-password"
              />
            </label>
          )}

          <div className="param-form-actions">
            <button type="button" className="param-btn" onClick={onClose} disabled={enCours}>
              Fermer
            </button>
            <button type="submit" className="param-btn param-btn-primary" disabled={enCours}>
              {enCours ? 'Enregistrement' : 'Enregistrer'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default AccesFormateurModal;
